export default __webpack_public_path__ + "static/media/4_1.76a5c3eb.png";